import { put, call }from "redux-saga/effects";
import { orderConstants } from '../actions/constants/orderConstants';
import OrderService from "../services/api/orderService";

 function* orderGetByFilter(request) {
	try {
		const result = yield call(OrderService.customerOrdersGetByFilter, request.input);
		if (result.data.isSuccess) {
			yield put({
				type: orderConstants.OrderGetByFilterSuccess,
				payload: result.data
			});
		}
		else {
			yield put({ type: orderConstants.OrderGetByFilterFailure, payload: result.data.status });
		}
	} catch (error) {
		yield put({ type: orderConstants.OrderGetByFilterFailure, payload: error });
	}
}

 function* orderRecurringGetByFilter(request) {
	try {
		const result = yield call(OrderService.orderGetByFilter, request.input);
		if (result.data.isSuccess) {
			yield put({
				type: orderConstants.OrderRecurringGetByFilterSuccess,
				payload: result.data
			});
		}
		else {
			yield put({ type: orderConstants.OrderRecurringGetByFilterFailure, payload: result.data.status});
		}
	} catch (error) {
		yield put({ type: orderConstants.OrderRecurringGetByFilterFailure, payload: error });
	}
}

export const orderSaga = {
	orderGetByFilter,
	orderRecurringGetByFilter
}